if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('change', this.onTierChange.bind(this));
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton =
          this.querySelector('[type="submit"]') ||
          document.querySelector(`[type="submit"][form="${this.form.getAttribute('id')}"]`);
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onTierChange(event) {
        const tierInput = event.target.closest('[data-wntn-card-tier]');
        if (!tierInput || !tierInput.checked) return;

        this.dataset.wntnSelectedTierQuantity = tierInput.value;
        const quantityInput = this.form.querySelector('[name="quantity"]');
        if (quantityInput) quantityInput.value = tierInput.value;

        const priceContainer = this.querySelector('[data-wntn-card-tier-price]');
        const currentPrice = priceContainer?.querySelector('[data-wntn-card-tier-current]');
        const comparePrice = priceContainer?.querySelector('[data-wntn-card-tier-compare]');
        const unitPrice = this.querySelector('[data-wntn-card-tier-unit-price]');
        if (currentPrice) currentPrice.textContent = tierInput.dataset.wntnTierPrice;
        if (comparePrice) {
          comparePrice.textContent = tierInput.dataset.wntnTierComparePrice;
          comparePrice.hidden = !tierInput.dataset.wntnTierComparePrice;
        }
        if (unitPrice) unitPrice.textContent = tierInput.dataset.wntnTierUnitPrice;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.upsellCheckInProgress) return;

        this.handleErrorMessage();

        if (this.isWntnUpsellProduct()) {
          this.upsellCheckInProgress = true;
          this.submitButton.setAttribute('aria-disabled', true);

          try {
            if (!(await this.hasWntnRegularCartProduct())) {
              this.handleErrorMessage(
                this.dataset.wntnUpsellMessage ||
                  'Upselling-Produkte können nur in Verbindung mit anderen Produkten gekauft werden.'
              );
              return;
            }
          } catch (error) {
            console.error('Upsell cart validation failed', error);
            this.handleErrorMessage(window.cartStrings?.error || 'Der Warenkorb konnte nicht geprüft werden.');
            return;
          } finally {
            this.upsellCheckInProgress = false;
            this.submitButton.removeAttribute('aria-disabled');
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const productInfo = document.getElementById(`ProductInfo-${this.dataset.sectionId}`) || this.closest('product-info');
        const selectedVolumeTier = productInfo?.querySelector(
          `input[name="wntn-volume-tier-${this.dataset.sectionId}"][data-tier-quantity]:checked`
        );
        const selectedFormTierQuantity = parseInt(this.dataset.wntnSelectedTierQuantity || '', 10);
        const selectedTierQuantity = selectedVolumeTier
          ? parseInt(selectedVolumeTier.dataset.tierQuantity || selectedVolumeTier.value, 10)
          : NaN;
        const formQuantityInput = this.form.querySelector('[name="quantity"]');
        const quantityInput = formQuantityInput || productInfo?.querySelector('[name="quantity"]');
        const formQuantity = parseInt(quantityInput?.value || '1', 10);
        let quantity = formQuantity;
        if (Number.isFinite(selectedFormTierQuantity)) {
          quantity = selectedFormTierQuantity;
        } else if (Number.isFinite(selectedTierQuantity)) {
          quantity = selectedTierQuantity;
        }
        if (quantityInput) {
          quantityInput.value = quantity;
        }
        if (!formQuantityInput) {
          const hiddenQuantityInput =
            this.form.querySelector('input[data-wntn-submit-quantity]') || document.createElement('input');
          hiddenQuantityInput.type = 'hidden';
          hiddenQuantityInput.name = 'quantity';
          hiddenQuantityInput.dataset.wntnSubmitQuantity = 'true';
          hiddenQuantityInput.value = quantity;
          if (!hiddenQuantityInput.parentNode) this.form.appendChild(hiddenQuantityInput);
        }

        const formData = new FormData(this.form);
        formData.set('quantity', quantity);
        const threeBoxVariantId = this.dataset.wntnThreeBoxVariantId;
        const hasSelectedVolumeTier = Number.isFinite(selectedFormTierQuantity) || selectedVolumeTier;
        const addThreeBox = threeBoxVariantId && hasSelectedVolumeTier && quantity === 3;
        const addCrateProperties = hasSelectedVolumeTier && quantity >= 6;
        if (addCrateProperties) {
          formData.set('properties[_wntn_pack_type]', 'kiste');
          formData.set('properties[_wntn_quantity_min]', '6');
          formData.set('properties[_wntn_quantity_step]', '6');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (addThreeBox) {
          config.headers['Content-Type'] = 'application/json';
          const properties = {};
          formData.forEach((value, key) => {
            if (key.startsWith('properties[') && key.endsWith(']')) {
              properties[key.slice(11, -1)] = value;
            }
          });
          const boxGroupId = `wntn-box-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const boxedProperties = {
            ...properties,
            _wntn_box_group: boxGroupId,
            _wntn_box_role: 'wine',
            _wntn_box_size: '3',
          };
          config.body = JSON.stringify({
            items: [
              {
                id: Number(formData.get('id')),
                quantity,
                properties: boxedProperties,
              },
              {
                id: Number(threeBoxVariantId),
                quantity: 1,
                properties: {
                  _wntn_box_group: boxGroupId,
                  _wntn_box_role: 'box',
                  _wntn_box_size: '3',
                },
              },
            ],
            sections: formData.get('sections'),
            sections_url: formData.get('sections_url'),
          });
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      isWntnUpsellProduct() {
        const marker = this.form.querySelector('[name="properties[_cart_upsell]"]')?.value;
        const productLink = this.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
        const productPath = productLink?.getAttribute('href') || window.location.pathname;
        return `${marker || ''}`.toLowerCase() === 'true' || `${productPath || ''}`.toLowerCase().includes('upsell');
      }

      isWntnUpsellCartLine(item) {
        const marker = `${item?.properties?._cart_upsell || ''}`.toLowerCase();
        const title = `${item?.product_title || item?.title || ''}`.toLowerCase();
        const handle = `${item?.handle || ''}`.toLowerCase();
        return marker === 'true' || title.includes('upsell') || handle.includes('upsell');
      }

      isWntnSupportCartLine(item) {
        const role = `${item?.properties?._wntn_box_role || ''}`.toLowerCase();
        return (
          item?.variant_id === 55334564692302 ||
          item?.variant_id === 55150991409486 ||
          item?.variant_id === 60685224673614 ||
          role === 'box' ||
          role === 'byob_box'
        );
      }

      async hasWntnRegularCartProduct() {
        const response = await fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);

        const cart = await response.json();
        return (cart.items || []).some(
          (item) => !this.isWntnSupportCartLine(item) && !this.isWntnUpsellCartLine(item)
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper && errorMessage) {
          this.errorMessageWrapper = document.createElement('div');
          this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
          this.errorMessageWrapper.setAttribute('role', 'alert');
          this.errorMessageWrapper.innerHTML = '<span class="product-form__error-message"></span>';
          this.form.before(this.errorMessageWrapper);
        }
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
